/**
 * Tooltip content for key concepts
 */
export const TOOLTIPS = {
  thesis:
    'An investment thesis is a specific belief about a market opportunity that guides your allocation decisions.',
  targetAllocation:
    'The percentage of your total portfolio you want allocated to this thesis.',
  allocationDrift:
    'The difference between your current and target allocation. Positive means over-allocated, negative means under-allocated.',
  philosophy:
    'Your overarching investment worldview. It contains multiple theses that together define your strategy.',
  healthScore:
    'A composite score (0-100) based on allocation drift, rule triggers, and performance. Higher is better.',
  rule:
    'An actionable trigger that monitors market conditions. When conditions are met, you receive an alert.',
  conditionType:
    'The type of market condition to monitor. Examples: price targets, drawdowns, ratios.',
  priority:
    'How urgent this rule is. Urgent rules trigger immediate alerts, normal rules are batched.',
  account:
    'A brokerage account or tax bucket (IRA, 401k, taxable). Used to organize holdings by tax treatment.',
  portfolio:
    'A strategic container for grouping holdings. Unlike accounts, portfolios organize by investment strategy.',
}
